import { useGetScheduleRequestListQueries } from '../../views/Calendar/EventsPanel/ScheduleActions/ScheduleRequests/hooks/useGetScheduleRequestListQueries';
import { useConvertScheduleRequestToEvent } from './use-convert-schedule-request-to-event';

type UseCalendarScheduleRequestsParams = {
  locationIds: string[];
  calendarDate: string;
};

export const useCalendarScheduleRequests = ({ locationIds, calendarDate }: UseCalendarScheduleRequestsParams) => {
  const { scheduleRequests, refetch } = useGetScheduleRequestListQueries({ locationIds, date: calendarDate });

  const { scheduleRequestEventsData, requestedAppointmentTypes } = useConvertScheduleRequestToEvent(scheduleRequests);

  return {
    scheduleRequests,
    requestedAppointmentTypes,
    scheduleRequestEventsData,
    refetchScheduleRequestList: refetch,
  };
};
